import { PiBackspace } from "react-icons/pi";
import { ActionSummaryData, ActionV2 } from "features/Resources/Shared/models";
import { displayActionType } from "features/Resources/Shared/helpers";
import GreyStatusButton from "./GreyStatusButton";

export default function SkippedStatus({ action }: { action: ActionV2 | ActionSummaryData }) {
  return (
    <GreyStatusButton icon={PiBackspace} iconProps={{ sx: { transform: "scaleX(-1)" } }}>
      {`${displayActionType(action)} Skipped`}
    </GreyStatusButton>
  );
}
